/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Duration_MinInputs */



/**
* | output |
* | --- |
* | "Duration too short" |
*
* @param {Qc_Fix_Duration_MinInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_duration_min = /** @type {((inputs?: Qc_Fix_Duration_MinInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Duration_MinInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée trop courte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer zu kurz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata troppo breve")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком короткая длительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración demasiado corta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("持续时间过短")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示時間が短すぎます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि बहुत छोटी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração demasiado curta")
	return /** @type {LocalizedString} */ ("Duration too short")
});